// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"style_headerLogo__1nevI"};